import React from 'react';
import L from 'leaflet';
import HabitatMetricLegend from 'src/shared/components/habitat-metric-legend/HabitatMetricLegend';
import { HabitatInsightsMetricGroup, HabitatInsightsMetricType, habitatInsightsMetricTypeGroupMap } from 'src/shared/types';
import styles from './PortfolioSiteExplorerMapLegend.module.scss';

type PortfolioSiteExplorerLegendProps = {
    selectedMetric: string;
};

const getSelectedMetricGroup = (metric: HabitatInsightsMetricType) => {
    return Object.keys(habitatInsightsMetricTypeGroupMap).find(metricGroup =>
        habitatInsightsMetricTypeGroupMap[metricGroup as HabitatInsightsMetricGroup].includes(metric)
    );
};

const PortfolioSiteExplorerMapLegend = (props: PortfolioSiteExplorerLegendProps) => {
    const { selectedMetric } = props;
    const isMetricSelected = selectedMetric && selectedMetric !== 'none';
    let selectedMetricGroup = getSelectedMetricGroup(selectedMetric as HabitatInsightsMetricType) || selectedMetric;

    // Use Connectivity group for both landcover and vegetation health
    if (selectedMetricGroup === HabitatInsightsMetricGroup.LAND_COVER) {
        selectedMetricGroup = 'COMBINED_VEGETATION_COVER';
    }
    if (selectedMetricGroup === HabitatInsightsMetricGroup.PRIMARY_PRODUCTIVITY) {
        selectedMetricGroup = 'VEGETATION_HEALTH';
    }

    return (
        <div
            className={styles.legend}
            ref={ref => {
                if (!ref) {
                    return;
                }
                L.DomEvent.disableClickPropagation(ref).disableScrollPropagation(ref);
            }}
        >
            <div className={styles.title}>Key</div>
            {isMetricSelected && selectedMetric && <HabitatMetricLegend selectedMetricGroup={selectedMetricGroup} />}
        </div>
    );
};

export default PortfolioSiteExplorerMapLegend;
